import { createSlice } from "@reduxjs/toolkit";
import { reorderEventSongs } from "./thunk";

export const initialState = {
  success: false,
  error: false,
  errorMessage: "",
  loading: false,
};

const eventSongReorderSlice = createSlice({
  name: "eventSongReorder",
  initialState,
  reducers: {
    eventSongReorderReset(state) {
      state.success = false;
      state.error = false;
      state.errorMessage = "";
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reorderEventSongs.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    });
    builder.addCase(reorderEventSongs.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(reorderEventSongs.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.success = false;
      state.errorMessage = action.payload?.message || "Failed to reorder songs";
    });
  },
});

export const { eventSongReorderReset } = eventSongReorderSlice.actions;
export default eventSongReorderSlice.reducer;
